
import { computed, defineComponent, ref } from 'vue';
import AppLazyImage from '@/components/UI/AppLazyImage.vue';
import AppVideoPlayer from '@/components/AppVideoPlayer.vue';
import { MEDIA_TYPES, PHOTO_VIEW_TYPE } from '@/types/enums';
import { IMedia } from '@/types/interfaces';
import { lowResUrlByViewType } from '@/helpers/lowResPhotoUrl';

export default defineComponent({
  components: { AppLazyImage, AppVideoPlayer },
  props: {
    media: { type: Object as () => IMedia, required: true },
    currentMedia: { type: Object as () => IMedia, required: true },
    pauseVideo: { type: Boolean, required: true },
    zoomable: { type: Boolean, default: true },
    showVideoPlayer: { type: Boolean, default: true },
  },
  emits: ['ifVideoPaused'],
  setup(props) {
    const baseURL = computed(() => process.env.VUE_APP_MEDIA_URL);
    const isPDF = computed(() => props.media.name?.includes('.pdf'));

    function openPdf(media) {
      const fileUrl = computed(() => (process.env.VUE_APP_MEDIA_URL || '') + media.fileUrl);
      window.open(fileUrl.value, '_blank');
    }
    return {
      baseURL,
      MEDIA_TYPES,
      PHOTO_VIEW_TYPE,
      isPDF,
      openPdf,
      lowResUrlByViewType,
    };
  },
});
